import React from 'react'
import { Row, Container } from 'react-bootstrap'
import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { useGetIntegrationAdminSettings } from '../../../hooks'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { MappingType } from '../../../../../../../models/Account'
import { BusinessEventType } from '../../../../../../../models/BusinessEvent'
import { CustomBusinessEventsAdminSettings } from './CustomBusinessEventsAdminSettings'
import { SelectBusinessEventTypeSection } from './SelectBusinessEventTypeSection'

interface BusinessEventsBodyProps {
  serviceId: IntegrationServiceId
  businessEventType: BusinessEventType
}

export const BusinessEventsBody: React.FC<BusinessEventsBodyProps> = ({ serviceId, businessEventType }) => {
  const { watch } = useFormContext<IntegrationSettings>()

  const mappingPath = `mappings.businessEvents.${businessEventType}` as const
  const currentBusinessEventMapping = watch(mappingPath)
  const currentMappingType = watch(`${mappingPath}.mappingType` as const)
  const isCustom = currentMappingType === MappingType.CUSTOM

  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountFetching) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container className='py-3'>
      <Row>
        <SelectBusinessEventTypeSection serviceId={serviceId} businessEventType={businessEventType} />
      </Row>

      {currentBusinessEventMapping && isCustom && (
        <Row>
          <CustomBusinessEventsAdminSettings serviceId={serviceId} businessEventType={businessEventType} />
        </Row>
      )}
    </Container>
  )
}
